import { put, call, select, delay, race } from 'redux-saga/effects'
import { createModal } from 'redux-saga-modal'
import {
  FETCH_LIST,
  SHOW_INFO_DIALOG,
  DELETE_RULE
} from './actionTypes'
import * as services from './services'
import * as actions from './actions'
import { message } from 'antd'


export default {

  *[FETCH_LIST]({ payload }) { // 获取分组列表数据
    const { params } = payload
    yield actions.toggleLoading()
    const { data, total } = yield call(services.fetchList, params)
    yield put(actions.listFetched({ data, total }))
    yield actions.toggleLoading()
  },

  *[SHOW_INFO_DIALOG]({ payload }) {
    const { params } = payload
    const modal = createModal('REFERRAL_RULE_DIALOG')
    yield modal.show(params)
    const { submit } = yield race({
      submit: modal.takeSubmit(),
      hide: modal.takeHide(),
    })
    if (submit) {
      yield modal.hide()
    } else {
      yield modal.destroy()
    }
  },

  *[DELETE_RULE]({ payload }) {
    const { id, isActive } = payload
    yield call(services.setActiveState, id, isActive)
    yield put(actions.updated(id, { isActive }))
    message.success('删除成功')
  },
}
